import http from "@/apis/http";
import url from "@/config/url";

const third_party = url.third_party;

export default {
  detail: {
    getColumns: (params) => http.post(third_party.public_sport.detail.columns, params),
    getData: (params) => http.post(third_party.public_sport.detail.search, params),
  },
  result:{
    getColumns: (params) => http.post(third_party.public_sport.result.columns, params),
    getData: (params) => http.post(third_party.public_sport.result.search, params),
  }
};
